import { useMemo } from "react";
import { ClientCurrentUser } from "../../types";
import { isCompassRole } from "../../schema/compassRole";

export type UserRoleInfo = {
    type: "advanced" | "readonly" | "basic";
    canAddUsers: boolean;
    canChangeOrg: boolean;
};

export function useUserRoleInfo(currentUser: ClientCurrentUser | null | undefined): UserRoleInfo {
    return useMemo(() => {
        const role = currentUser?.role;

        // Both Compass roles get full discussion-management write access:
        // adding recipients (including private discussions) and changing the
        // org filter. The server already accepts COMPASS_USER on the create
        // and addParticipants endpoints; this hook was the only remaining
        // restriction. Mirrors `DiscussionService.canEditParticipants`.
        if (isCompassRole(role)) {
            return { type: "advanced", canAddUsers: true, canChangeOrg: true };
        }

        if (role === "READONLY_USER") {
            return { type: "readonly", canAddUsers: false, canChangeOrg: false };
        }

        // Default → basic
        return { type: "basic", canAddUsers: false, canChangeOrg: false };
    }, [currentUser?.role]);
}
